import React from "react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Acceuil from "./components/Acceuil"; // Page Principale
import MentionLegal from "./components/MentionLegal";

const App = () => {
  return (
    <HashRouter basename="/">
      <Routes>
        <Route path="/" element={<Acceuil />} />
        <Route path="/mention-legal" element={<MentionLegal />} />
      </Routes>
    </HashRouter>
  );
};

export default App;
